module.exports = __webpack_public_path__ + "static/media/mobile-bg-about.fab7e29b.png";